import clsx from "clsx";
import { bookingStatusLabel } from "@/lib/bookingStatus";
import { invoiceStatusLabel } from "@/lib/invoiceStatus";

const STATUS_STYLES: Record<string, string> = {
  draft: "bg-fill-tertiary text-label-secondary",
  requested: "bg-status-orange/15 text-status-orange",
  reserved: "bg-amber-500/15 text-amber-700 dark:text-amber-400",
  confirmed: "bg-status-green/15 text-status-green",
  checked_in: "bg-accent-soft text-accent",
  checked_out: "bg-fill-secondary text-label-secondary",
  cancelled: "bg-status-red/15 text-status-red",
  rejected: "bg-status-red/15 text-status-red",
  no_show: "bg-status-red/10 text-status-red/80",
  pending: "bg-status-orange/15 text-status-orange",
  issued: "bg-accent-soft text-accent",
  partially_paid: "bg-amber-500/15 text-amber-700 dark:text-amber-400",
  paid: "bg-status-green/15 text-status-green",
};

export interface StatusBadgeProps {
  status: string;
  className?: string;
  /** Buchungs- oder Rechnungsstatus-Labels */
  kind?: "booking" | "invoice";
}

export function StatusBadge({ status, className, kind = "booking" }: StatusBadgeProps) {
  const key = status.toLowerCase().replace(/\s+/g, "_");
  const label = kind === "invoice" ? invoiceStatusLabel(status) : bookingStatusLabel(status);
  return (
    <span
      className={clsx(
        "inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium",
        STATUS_STYLES[key] ?? "bg-fill-tertiary text-label-secondary",
        className,
      )}
    >
      {label}
    </span>
  );
}
